// Serie giornaliere degli Open Data della qualita' dell'aria (grafico di OpenDataAirQuality):
// per ogni grandezza la media del giorno su tutte le aree. I valori passano da
// normalizeMetricValue come quelli della mappa della stessa pagina: ozono in ppb (il dato e' in
// centesimi), AQI sulla scala EPA 0-500 (il dato del dispositivo per 2). Funzione pura.

import { airMetricOrder, normalizeMetricValue } from "../constants/airQuality";

/**
 * Righe di `public/ugo-metrics-data` con la grandezza sotto il suo nome. I file mensili degli Open
 * Data su disco (`CachingService`) chiamano `aqi_fast` un valore che e' l'AQI EPA: si traduce qui,
 * al confine, per non doverli rigenerare.
 */
export function withAqiEpa(rows) {
    return (rows || []).map(({ aqi_fast, ...row }) => ({ ...row, aqi_epa: aqi_fast }));
}

/** `{ [metricKey]: [{ day, value }] }`, giorni in ordine crescente, solo i giorni con dati. */
export function buildDailySeries(rows) {
    const result = {};
    airMetricOrder.forEach(k => {
        result[k] = [];
    });
    if (!Array.isArray(rows)) return result;

    const byDay = {};
    rows.forEach(row => {
        const day = row.day;
        if (!day) return;
        if (!byDay[day]) {
            byDay[day] = {};
            airMetricOrder.forEach(k => {
                byDay[day][k] = { sum: 0, count: 0 };
            });
        }
        airMetricOrder.forEach(metricKey => {
            const num = normalizeMetricValue(metricKey, row[metricKey]);
            if (num == null) return;
            byDay[day][metricKey].sum += num;
            byDay[day][metricKey].count += 1;
        });
    });

    airMetricOrder.forEach(metricKey => {
        result[metricKey] = Object.entries(byDay)
            .map(([day, metrics]) => {
                const { sum, count } = metrics[metricKey];
                return count === 0 ? null : { day, value: sum / count };
            })
            .filter(Boolean)
            .sort((a, b) => (a.day < b.day ? -1 : 1));
    });
    return result;
}
